<template>
  <div class="flex flex-col gap-2">
    <span class="text-xs md:text-sm tracking-wide"><slot></slot></span>
    <span class="text-xl md:text-4xl font-extrabold tracking-tighter"><slot name="value" /></span>
  </div>
</template>
<script lang="ts" setup></script>
